import _ from 'underscore'

const MEASUREMENT_CANVAS = document.createElement('canvas').getContext('2d')

// These were measured in Chrome. For each typeface, the letter M was
// measured at a 10px font size. The resulting ratios are the browser's
// reported height (which includes line height) divided by the reported
// width
// TODO: Add a test around this to blow up if we add a new font and don't
// provide a measurement for its ratio
export const FONT_RATIOS = {
  Georgia: 11 / 9.27,
  Helvetica: 11.5 / 8.33,
  'Lucida Grande': 11.5 / 8.61,
  'ff-netto-web': 12.5 / 7.58,
  'proxima-nova': 12 / 8.08,
  'ff-tisa-web-pro': 16.5 / 8.94,
  'Source Sans Pro': 13.5 / 7.27,
  'source-sans-pro': 13.5 / 7.27,
  'droid-sans-mono': 12 / 6, // Droid Sans Mono has been removed from the font selection dropdown, but existing polls may still have it set.
  // Custom Japanese Fonts
  'MS PGothic': 10 / 10,
  'MS Gothic': 10 / 10,
  'MS UI Gothic': 10 / 10,
  'ヒラギノ角ゴ Pro W3': 10 / 10,
  'Hiragino Kaku Gothic Pro': 10 / 10,
  Osaka: 10 / 10,
  メイリオ: 10 / 10,
  Meiryo: 10 / 10,
  // Custom English Fonts
  Arial: 10 / 8.34,
  HelveticaNeue: 11.64 / 8.7,
  vw: 12.2 / 8.06,
  Metric: 10 / 10,
  Splunk: 12 / 8.47
}

const measureTextString = _.memoize(function (text, font, fontSize) {
  const context = MEASUREMENT_CANVAS
  // TODO: make sure keywords, totals, counting axis, and labels are all baselined to 10px or some other value
  context.font = `${fontSize} ${font}`
  const heightToWidthRatio = FONT_RATIOS[font] || 1.4

  // http://stackoverflow.com/questions/1134586/how-can-you-find-the-height-of-text-on-an-html-canvas
  const dimensions = {
    width: context.measureText(text, font, fontSize).width,
    height: context.measureText('M', font, fontSize).width * heightToWidthRatio
  }

  return JSON.stringify(dimensions)
}, (...args) => {
  return JSON.stringify(args)
})

export function measureText (text, font, fontSize = '10px') {
  const dimensionString = measureTextString(text, font, fontSize)
  return JSON.parse(dimensionString)
}
